<template lang="pug">
    v-container
        v-btn(tile='' @click="exportToCsv()" outlined='' x-small="" color='#008E95').mx-2
            p exportar historial (.csv)
        v-row.justify-center
            //-
              v-col(cols="4")
                  v-select(:items="items" item-text="name" item-value="val" label="Seleccionar..." v-model="currentType")
            v-col(cols="12")
              v-select(
                label='Tienda',
                :items='locations',
                v-model='currentLocation',
                return-object, outlined
                clearable='', @input='selectShop',
                @click:clear='clearShopSelection').pt-2.mr-n1.mb-n10
                template(slot='selection', slot-scope='data')
                  v-col
                    v-avatar(size='22px')
                      img( style='object-fit:cover; max-width: 42px' :src='getImageShop(data.item.pictures.imageInput1)' )
                  v-col.ml-1(style='font-size:8px;')
                    | {{ data.item.name }}
                template(slot='item', slot-scope='data')
                  v-avatar(size='22px')
                    img(style='object-fit:cover; max-width: 42px' :src='getImageShop(data.item.pictures.imageInput1)')
                  v-list-tile-content
                    v-list-tile-title(v-html='data.item.name' style='font-size:8px;')
            v-col(cols="5")
                v-menu(v-model="modalDateFrom" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y="" min-width="290px")
                  template(v-slot:activator="{ on }")
                      v-text-field(:value="dateFromFormated" label="Fecha de inicio" prepend-icon="mdi-calendar" readonly="" v-on="on")
                  v-date-picker(v-if="modalDateFrom" v-model="dateFrom" @input="modalDateFrom = false")
            v-col(cols="5")
                v-menu(v-model="modalDateTo" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y="" min-width="290px")
                  template(v-slot:activator="{ on }")
                      v-text-field(:value="dateToFormated" label="Fecha de fin" prepend-icon="mdi-calendar" readonly="" v-on="on")
                  v-date-picker(v-if="modalDateTo" v-model="dateTo" @input="modalDateTo = false")
            v-col(cols="1")
                v-btn.main-filter__refresh-btn.ma-2.ml-n4(:loading='isLoading', :disabled='isLoading', fab small color='success', @click="filterByDate('change')" )
                    v-icon( small) mdi-cached
        v-row.pa-0.ma-0
            v-col(cols="4")
                v-btn(tile='' outlined='' small="" color='#008E95' @click="preset = 'today'").px-1
                    p HOY
            v-col(cols="4")
                v-btn(tile='' outlined='' small="" color='#008E95' @click="preset = 'week'").px-1
                    p ESTA SEMANA
            v-col(cols="4")
                v-btn(tile='' outlined='' small="" color='#008E95' @click="preset = 'month'").px-1
                    p ESTE MES
        v-row
          v-col(cols='12')
            v-tabs(v-model="tab" align-with-title="" show-arrows)
              v-tabs-slider(color="primary")
              v-tab(v-if="item.type !== 'ingredient'" @click="currentType = 'sales'") Ventas {{ numberFormat(summary.sales.total)}}
              v-tab(@click="currentType = 'purchases'") Compras {{ numberFormat(summary.purchases.total)}}
              v-tab(@click="currentType = 'transfers'") Transferencias {{numberFormat(summary.transfers.total)}}
            v-tabs-items(v-model="tab").mt-4
              v-tab-item
                v-card(flat="")
                  v-col(v-if="item.type !== 'ingredient'" cols='12')
                    v-skeleton-loader.mx-auto(:transition='transition' v-if='summary.sales.isLoading || plotLoading'  type='card')
                    BarChart(v-else :chart-data='summary.sales' :options="optionsChartsSalesPurchases")
              v-tab-item
                v-card(flat="")
                  v-col(cols="12")
                    v-skeleton-loader.mx-auto(:transition='transition' v-if='summary.purchases.isLoading || plotLoading'  type='card')
                    BarChart(v-else :chart-data='summary.purchases' :options="optionsChartsSalesPurchases")
              v-tab-item
                v-card(flat="")
                  v-col(cols="12")
                    v-skeleton-loader.mx-auto(:transition='transition' v-if='summary.transfers.isLoading || plotLoading'  type='card')
                    BarChart(v-else :chart-data='summary.transfers' :options="optionsCharts")
</template>

<script>
  // import { mapActions, mapState } from 'vuex'
  import moment from 'moment'
  import Vue from 'vue'
  import LineChart from '@/components/custom/charts/LineChart'
  import BarChart from '@/components/custom/charts/BarChart'
  import shopPlaceHolder from '@/assets/icons/shop.svg'

  export default {
    name: 'ProductLogFilter',
    components: {
      LineChart,
      BarChart,
    },
    props: {
      item: Object,
    },
    data () {
      return {
        currentLocation: null,
        plotLoading: false,
        tab: null,
        preset: 'today',
        modalDateFrom: false,
        modalDateTo: false,
        menu: false,
        modal: false,
        menu2: false,
        dateFrom: '',
        dateTo: '',
        dateToFormated: '',
        dateFromFormated: '',
        currentType: this.item.type !== 'ingredient' ? 'sales' : 'purchases',
        transition: 'scale-transition',
        summary: {
          sales: {
            labels: [],
            datasets: [{
              label: 'Ventas',
              borderWidth: 1,
              backgroundColor: [
                'rgba(0, 202, 227, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
              ],
              borderColor: [
                'rgba(0, 202, 227, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                'rgba(255,99,132,1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
              ],
              pointBorderColor: '#2554FF',
              data: [],
              data1: [],
            }],
            isLoading: false,
          },
          transfers: {
            labels: [],
            datasets: [{
              label: 'Transferencias',
              borderWidth: 1,
              backgroundColor: [
                'rgba(0, 202, 227, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
              ],
              borderColor: [
                'rgba(0, 202, 227, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                'rgba(255,99,132,1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
              ],
              pointBorderColor: '#2554FF',
              data: [],
            }],
            isLoading: false,
          },
          purchases: {
            labels: [],
            datasets: [{
              label: 'Compras',
              borderWidth: 1,
              backgroundColor: [
                'rgba(0, 202, 227, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
              ],
              borderColor: [
                'rgba(0, 202, 227, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                'rgba(255,99,132,1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
              ],
              pointBorderColor: '#2554FF',
              data: [],
              data1: [],
            }],
            isLoading: false,
          },
        },
      }
    },
    computed: {
      items () {
        const itemsTemp = []
        if (this.item.type !== 'ingredient') {
          itemsTemp.push({ name: 'ventas', val: 'sales' })
        }
        itemsTemp.push({ name: 'compras', val: 'purchases' })
        itemsTemp.push({ name: 'traslados', val: 'transfers' })
        return itemsTemp
      },
      isLoading () {
        return this.$store.state.products.isLoading
      },
      optionsCharts () {
        return {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: false,
        }
      },
      optionsChartsSalesPurchases () {
        const vm = this
        return {
          tooltips: {
            mode: 'label',
            callbacks: {
              title: function (tooltipItem, data) {
                return data.labels[tooltipItem[0].index]
              },

              label: function (tooltipItem, data) {
                // console.log(tooltipItem)
                return data.datasets[tooltipItem.datasetIndex].label + ': ' + vm.numberFormat(tooltipItem.yLabel)
              },

              afterLabel: function (tooltipItem, data) {
                return 'cantidad: ' + data.datasets[tooltipItem.datasetIndex].data1[tooltipItem.index]
              },
            },
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: false,
        }
      },
      locations () {
        return this.$store.getters['shops/getItems']
      },
    },
    watch: {
      currentType (newVal, oldVal) {
        this.filterByDate('notchange')
      },
      preset (newVal, oldVal) {
        this.filterByDatePreset(newVal)
      },
      dateFrom (val) {
        this.dateFromFormated = moment(val).format('DD-MM-YYYY')
        // this.dateFromFormated = this.formatDate(this.dateFrom)
      },
      dateTo (val) {
        this.dateToFormated = this.formatDate(this.dateTo)
      },
    },
    created () {
      this.initialMetrics()
    },
    /* mounted () {
      const vm = this
      vm.filterByDate('notchange')
    }, */
    methods: {
      numberFormat (val) {
        if (val || val === 0) { return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '$0 '
      },
      selectShop (item) {
        const vm = this
        // console.log(item)
        vm.$store.dispatch('products/setShop', item).then(function () {
        })
      },
      clearShopSelection () {
        const vm = this
        vm.$store.dispatch('products/setShop', null).then(function () {
        })
      },
      getImageShop (url) {
        if (url === '') {
          return shopPlaceHolder
        } else {
          return url
        }
      },
      formatDate (date) {
        return moment(date).format('DD-MM-YYYY')
      },
      exportToCsv () {
        const vm = this
        const data = [vm.dateFrom, vm.dateTo, [vm.summary.sales.total, vm.summary.purchases.total, vm.summary.transfers.total]]
        vm.$store.dispatch('products/exportProductRecord', data).then(res => {
          // console.log('temrine csv')
        })
      },
      initialMetrics () {
        const vm = this
        vm.$store.dispatch('loading/setLoading', true)
        vm.loadSummaryCharts('today', 'sales', vm.summary.sales, null, null)
        vm.loadSummaryCharts('today', 'purchases', vm.summary.purchases, null, null)
        vm.loadSummaryCharts('today', 'transfers', vm.summary.transfers, null, null)
        vm.dateFrom = moment().format('YYYY-MM-DD')
        vm.dateTo = vm.dateFrom
        vm.$store.dispatch('products/loadProductLog', [vm.currentType, vm.dateFrom, moment(vm.dateTo).add(1, 'days').format('YYYY-MM-DD')])
          .then(function () {

          })
          .catch(function (err) {
            console.log(err)
          })
      },
      filterSummary () {
        /* if (this.preset === 'today') {
          this.initialMetrics()
        } else { */
        let presetMetrics
        const momentFrom = Vue.moment(this.dateFrom)
        const momentTo = Vue.moment(this.dateTo)
        const differenceInDays = momentTo.diff(momentFrom, 'days')
        // este preset es para los labels. No es para calcular fechas
        if (differenceInDays === 1) {
          presetMetrics = 'today'
        } else if (differenceInDays <= 7) {
          presetMetrics = 'week'
        } else if (differenceInDays <= 31) {
          presetMetrics = 'month'
        } else {
          presetMetrics = 'year'
        }
        const vm = this
        vm.$store.dispatch('loading/setLoading', true)
        vm.loadSummaryCharts(presetMetrics, 'sales', vm.summary.sales, this.dateFrom, this.dateTo)
        vm.loadSummaryCharts(presetMetrics, 'purchases', vm.summary.purchases, this.dateFrom, this.dateTo)
        vm.loadSummaryCharts(presetMetrics, 'transfers', vm.summary.transfers, this.dateFrom, this.dateTo)
        // }
      },
      loadSummaryCharts (preset, type, callback, from, to) {
        callback.isLoading = true
        const data = {
          user_id: this.$store.state.users.user.uid,
          item_id: this.item.id,
          preset: preset,
          type: type,
          dateFrom: from,
          dateTo: to,
        }
        this.$store.dispatch('summary/summaryByProduct', data).then(res => {
          if (type === 'sales') {
            callback.labels = Object.keys(res.data.resultsCost)
            callback.datasets[0].data = Object.values(res.data.resultsCost)
            callback.datasets[0].data1 = Object.values(res.data.results)
            callback.total = res.data.total
          } else if (type === 'purchases') {
            callback.labels = Object.keys(res.data.resultsCost)
            callback.datasets[0].data = Object.values(res.data.resultsCost)
            callback.datasets[0].data1 = Object.values(res.data.results)
            callback.total = Object.values(res.data.resultsCost).reduce((a, b) => a + b, 0)
          } else {
            callback.labels = Object.keys(res.data.results)
            callback.datasets[0].data = Object.values(res.data.results)
            callback.total = Object.values(res.data.results).reduce((a, b) => +a + +b, 0)
          }
          callback.isLoading = false
          this.$store.dispatch('summary/setChart', [type, callback])
        }).catch(e => {
          callback.isLoading = false
          // console.log(e)
        })
      },

      filterByDate (val) {
        const vm = this
        if (val === 'change') {
          vm.filterSummary()
        }
        vm.$store.dispatch('products/loadProductLog', [vm.currentType, moment(vm.dateFrom).format('YYYY-MM-DD'), moment(vm.dateTo).add(1, 'days').format('YYYY-MM-DD')])
          .then(function () {

          })
          .catch(function (err) {
            console.log(err)
          })
      },
      filterByDatePreset (val) {
        const vm = this
        switch (val) {
          case 'today':
            vm.dateFrom = moment().format('YYYY-MM-DD')
            vm.dateTo = vm.dateFrom
            break
          case 'week':

            vm.dateFrom = moment().startOf('isoWeek').format('YYYY-MM-DD')
            vm.dateTo = moment().endOf('isoWeek').format('YYYY-MM-DD')
            break
          case 'month':

            vm.dateFrom = moment().startOf('month').format('YYYY-MM-DD')
            vm.dateTo = moment().endOf('month').format('YYYY-MM-DD')
            break
        }
        vm.filterSummary()
        vm.$store.dispatch('products/loadProductLog', [vm.currentType, vm.dateFrom, moment(vm.dateTo).add(1, 'days').format('YYYY-MM-DD')])
          .then(function () {

          })
          .catch(function (err) {
            console.log(err)
          })
      },
    },
  }
</script>

<!--<style scoped lang="scss">-->
    <!--// New Breakpoints-->
    <!--@import '@/styles/custom/mixins.scss';-->
    <!--.main-filter{-->
        <!--display: flex;-->
        <!--flex-direction: row;-->
        <!--margin: auto;-->
        <!--max-width: 700px;-->

        <!--&__button-row{-->
            <!--box-shadow: none;-->
            <!--&&#45;&#45;left{-->
                <!--display: flex;-->
                <!--flex-direction: column;-->
                <!--margin-right: 2px;-->

                <!--button{-->
                    <!--flex: 1;-->
                <!--}-->
            <!--}-->
            <!--&&#45;&#45;right{-->
                <!--flex-direction: column;-->
                <!--width: 100%;-->
                <!--@include break-up("phablet"){-->
                    <!--width: 500px;-->
                    <!--flex-direction: row;-->
                    <!--button{-->
                        <!--flex:1;-->
                    <!--}-->
                <!--}-->
            <!--}-->
            <!--button{-->

            <!--}-->
        <!--}-->
        <!--&__input-container{-->
            <!--margin: auto !important;-->
            <!--width: 100%;-->
            <!--display: flex;-->
            <!--flex-direction: column;-->
            <!--align-items: flex-start;-->
            <!--flex-wrap: wrap;-->
            <!--@include break-up('phablet'){-->
                <!--flex-direction:row;-->
                <!--align-items: center;-->
            <!--}-->
        <!--}-->
        <!--&__date-pickers{-->
            <!--display: flex;-->
            <!--flex-direction: column;-->

            <!--@include break-up('phablet'){-->
                <!--flex-direction:row;-->
                <!--max-width: 400px;-->
            <!--}-->
        <!--}-->
        <!--&__date{-->
            <!--@include break-up('phablet'){-->

            <!--}-->

            <!--display: flex;-->
            <!--flex-direction: column;-->
            <!--align-items: center;-->
            <!--justify-content: center;-->
            <!--margin: 10px;-->
        <!--}-->
        <!--&__date-container{-->
            <!--flex: 1;-->
        <!--}-->
        <!--&__refresh-btn {-->
            <!--width: 100px !important;-->
        <!--}-->
    <!--}-->
    <!--.custom-loader {-->
        <!--animation: loader 1s infinite;-->
        <!--display: flex;-->
    <!--}-->
    <!--@-moz-keyframes loader {-->
        <!--from {-->
            <!--transform: rotate(0);-->
        <!--}-->
        <!--to {-->
            <!--transform: rotate(360deg);-->
        <!--}-->
    <!--}-->
    <!--@-webkit-keyframes loader {-->
        <!--from {-->
            <!--transform: rotate(0);-->
        <!--}-->
        <!--to {-->
            <!--transform: rotate(360deg);-->
        <!--}-->
    <!--}-->
    <!--@-o-keyframes loader {-->
        <!--from {-->
            <!--transform: rotate(0);-->
        <!--}-->
        <!--to {-->
            <!--transform: rotate(360deg);-->
        <!--}-->
    <!--}-->
    <!--@keyframes loader {-->
        <!--from {-->
            <!--transform: rotate(0);-->
        <!--}-->
        <!--to {-->
            <!--transform: rotate(360deg);-->
        <!--}-->
    <!--}-->
<!--</style>-->
